import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SchedaEsecuzione } from 'src/app/common/models/scheda-esecuzione';
import { PropertiesSettings } from "../../../../core/configuration/properties-settings";

@Component({
    selector: '[add_doc_to_scheda_esecuzione]',
  templateUrl: 'add-to-scheda-esecuzione.component.html',
})

export class AddDocumentoToSchedaEsecuzioneComponent {
  readonly PROPERTIES_SETTINGS = PropertiesSettings;
  @Input()
  entity: SchedaEsecuzione;
  @Output()
  onClickAddToEntity = new EventEmitter();

  emitEntity(schedaEsecuzione: SchedaEsecuzione) {
    this.onClickAddToEntity.emit(schedaEsecuzione);
  }
}
